// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import ConfigHandler from '../../loaders/handlers/ConfigHandler';
import Joint from '../../animationpack/Joint';
import Skeleton from '../../animationpack/Skeleton';
import SkeletonPose from '../../animationpack/SkeletonPose';
import ObjectUtils from '../../util/ObjectUtils';
import Matrix4 from '../../math/Matrix4';

/**
 * Handler for loading skeletons into engine
 */
class SkeletonHandler extends ConfigHandler {

  /**
   * @param {...*} args {@link ConfigHandler} constructor arguments.
   */
  constructor(...args) {
    super(...args);
  }

  _create() {
    const skeleton = new Skeleton('', []);
    const pose = new SkeletonPose(skeleton);
    return pose;
  }

  /**
   * Adds/updates/removes a skeleton. A Skeleton is created once and then reused, but skeletons
   * are rarely updated.
   * @param {string} ref
   * @param {Object} config
   * @param {Object} options
   * @returns {Promise} Resolves with the updated entity or null if removed
   */
  _update(ref, config, options) {
    return ConfigHandler.prototype._update.call(this, ref, config, options).then((pose) => {
      if (!config) {
        return Promise.resolve();
      }
      const joints = [];
      ObjectUtils.forEach(config.joints, (jointConfig) => {
        const joint = new Joint(jointConfig.name);
        joint._index = jointConfig.index;
        joint._parentIndex = jointConfig.parentIndex;
        tmpMatrix.setArray(jointConfig.inverseBindPose);
        joint._inverseBindPose.fromMatrix(tmpMatrix);

        joints.push(joint);
      }, null, 'index');

      pose.id = config.id;
      pose._skeleton._name = config.name;
      pose._skeleton._joints = joints;
      pose.allocateTransforms();
      pose.setToBindPose();

      return Promise.resolve(pose);
    });
  }
}

ConfigHandler._registerClass('skeleton', SkeletonHandler);
const tmpMatrix = new Matrix4();
export default SkeletonHandler;
